<div class="studio-space-input">
  <div class="studio-space-input__panel">
    <div class="studio-space-input__modes" role="tablist" aria-label="Spacing mode">
      @for (mode of modeOptions; track mode.id) {
        <button
          type="button"
          class="studio-space-input__mode"
          [class.is-active]="activeMode === mode.id"
          (click)="setMode(mode.id)"
        >
          {{ mode.label }}
        </button>
      }
    </div>

    <div class="studio-space-input__body">
      @if (activeMode === 'all') {
        <div class="studio-space-input__single">
          <app-studio-measure-input
            [value]="allValue"
            [config]="config"
            (valueChange)="updateAll($event)"
          ></app-studio-measure-input>
        </div>
      }

      @if (activeMode === 'axis') {
        <div class="studio-space-input__details">
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ axisPrimaryLabel }}</span>
            <app-studio-measure-input
              [value]="axisPrimary"
              [config]="config"
              (valueChange)="updateAxisPrimary($event)"
            ></app-studio-measure-input>
          </div>
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ axisSecondaryLabel }}</span>
            <app-studio-measure-input
              [value]="axisSecondary"
              [config]="config"
              (valueChange)="updateAxisSecondary($event)"
            ></app-studio-measure-input>
          </div>
        </div>
      }

      @if (activeMode === 'detailed') {
        <div class="studio-space-input__details">
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ detailedLabels[0] }}</span>
            <app-studio-measure-input
              [value]="detailTop"
              [config]="config"
              (valueChange)="updateDetailed(0, $event)"
            ></app-studio-measure-input>
          </div>
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ detailedLabels[1] }}</span>
            <app-studio-measure-input
              [value]="detailRight"
              [config]="config"
              (valueChange)="updateDetailed(1, $event)"
            ></app-studio-measure-input>
          </div>
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ detailedLabels[2] }}</span>
            <app-studio-measure-input
              [value]="detailBottom"
              [config]="config"
              (valueChange)="updateDetailed(2, $event)"
            ></app-studio-measure-input>
          </div>
          <div class="studio-space-input__detail">
            <span class="studio-space-input__label">{{ detailedLabels[3] }}</span>
            <app-studio-measure-input
              [value]="detailLeft"
              [config]="config"
              (valueChange)="updateDetailed(3, $event)"
            ></app-studio-measure-input>
          </div>
        </div>
      }
    </div>
  </div>
</div>
